import { Outlet } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";
import { LoadingPage } from "@/components/common/loading";

export function PrivateRoute() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return <LoadingPage />;
  if (isAuthenticated) return <Outlet />;

  window.location.href = "https://app.sandbox.ginja.ai/login";
  return null;
}
